import React from 'react';
import useHedgeFeeMode from '../hooks/useHedgeFeeMode';

// Переключатель «без комиссии / с комиссией хеджа» (CR-F18-019). Комиссия — расчётная (ставка мейкера или тейкера на эмиссии × исполненный объём),
// симулятор её с балансов не списывает; числа с комиссией и без приходят из BFF готовыми, здесь только выбор.
export default function HedgeFeeToggle({ compact = false }) {
  const [mode, setMode] = useHedgeFeeMode();
  const btn = (key, label, hint) => (
    <button key={key} type="button" onClick={() => setMode(key)} aria-pressed={mode === key} title={hint} data-testid={`fee-mode-${key}`}
      style={{
        padding: '1px 10px', borderRadius: 6, fontSize: 12, cursor: 'pointer',
        border: '1px solid ' + (mode === key ? '#4fb0d8' : '#2a4a5a'),
        background: mode === key ? 'rgba(79,176,216,0.18)' : 'transparent', color: mode === key ? '#dfe6ee' : '#9fb2c2',
      }}>{label}</button>
  );
  return (
    <span data-testid="fee-mode-toggle" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {compact ? null : <span style={{ fontSize: 12, color: '#8a9aa8' }}>Заработок:</span>}
      {btn('gross', 'без комиссии', 'как раньше: результат сделок без комиссии хеджа')}
      {btn('net', 'с комиссией хеджа', 'за вычетом расчётной комиссии хеджа (ставка мейкера или тейкера × исполненный объём)')}
    </span>
  );
}
